import type { Team } from "@/types";

export const teams: Team[] = [
  {
    id: "t-lal",
    name: "湖人",
    city: "洛杉矶",
    abbreviation: "LAL",
    conference: "西部",
    primaryColor: "#552583",
    secondaryColor: "#FDB927",
    arena: "加密科普竞技场",
    record: "42胜22负",
    coach: "加布里埃尔·雷耶斯",
    founded: 1947,
    description:
      "洛杉矶湖人是一支底蕴深厚的西部豪门球队，以华丽的进攻体系与明星阵容著称。本赛季球队在攻防两端都展现出统治力，主场胜率位列联盟前列，是季后赛的有力争夺者。",
    players: [
      { name: "勒布朗·詹姆斯", number: 23, position: "前锋", points: 25.4, rebounds: 7.8, assists: 8.1 },
      { name: "安东尼·戴维斯", number: 3, position: "大前锋", points: 24.1, rebounds: 12.3, assists: 3.5 },
      { name: "奥斯汀·里夫斯", number: 15, position: "后卫", points: 15.6, rebounds: 4.2, assists: 5.4 },
      { name: "德安吉洛·拉塞尔", number: 1, position: "控卫", points: 17.2, rebounds: 3.1, assists: 6.3 },
      { name: "八村塁", number: 28, position: "前锋", points: 12.8, rebounds: 4.6, assists: 1.4 },
    ],
  },
  {
    id: "t-bos",
    name: "凯尔特人",
    city: "波士顿",
    abbreviation: "BOS",
    conference: "东部",
    primaryColor: "#007A33",
    secondaryColor: "#BA9653",
    arena: "TD花园球馆",
    record: "48胜16负",
    coach: "迈克尔·奥科菲",
    founded: 1946,
    description:
      "波士顿凯尔特人是联盟历史最成功的球队之一。球队强调团队篮球与外线投射，本赛季三分命中率联盟领先，防守效率同样位居联盟前三，是总冠军的热门候选。",
    players: [
      { name: "杰森·塔图姆", number: 0, position: "小前锋", points: 27.3, rebounds: 8.4, assists: 5.1 },
      { name: "杰伦·布朗", number: 7, position: "得分后卫", points: 23.6, rebounds: 5.7, assists: 3.6 },
      { name: "德里克·怀特", number: 9, position: "控卫", points: 15.2, rebounds: 4.1, assists: 5.3 },
      { name: "克里斯塔普斯·波尔津吉斯", number: 8, position: "中锋", points: 19.8, rebounds: 6.9, assists: 2.1 },
      { name: "朱·霍勒迪", number: 4, position: "后卫", points: 12.4, rebounds: 5.2, assists: 4.8 },
    ],
  },
  {
    id: "t-gsw",
    name: "勇士",
    city: "金州",
    abbreviation: "GSW",
    conference: "西部",
    primaryColor: "#1D428A",
    secondaryColor: "#FFC72C",
    arena: "大通中心",
    record: "38胜28负",
    coach: "史蒂夫·科尔曼",
    founded: 1946,
    description:
      "金州勇士以流畅的传切体系与快速三分出手闻名，是近年联盟最具观赏性的球队之一。球队擅长利用无球跑动制造空位机会，主场氛围火爆，深得球迷喜爱。",
    players: [
      { name: "斯蒂芬·库里", number: 30, position: "控卫", points: 28.7, rebounds: 4.5, assists: 6.2 },
      { name: "克莱·汤普森", number: 11, position: "得分后卫", points: 18.9, rebounds: 3.6, assists: 2.4 },
      { name: "德雷蒙德·格林", number: 23, position: "大前锋", points: 8.6, rebounds: 7.2, assists: 6.8 },
      { name: "安德鲁·维金斯", number: 22, position: "小前锋", points: 14.3, rebounds: 4.9, assists: 2.2 },
      { name: "乔纳森·库明加", number: 4, position: "前锋", points: 16.1, rebounds: 4.8, assists: 2.7 },
    ],
  },
  {
    id: "t-mil",
    name: "雄鹿",
    city: "密尔沃基",
    abbreviation: "MIL",
    conference: "东部",
    primaryColor: "#00471B",
    secondaryColor: "#EEE1C6",
    arena: "论坛球馆",
    record: "44胜20负",
    coach: "大卫·格里芬",
    founded: 1968,
    description:
      "密尔沃基雄鹿以内线统治力与转换进攻见长，拥有联盟顶级的禁区终结能力。球队防守体系严密，篮板保护出色，东部排名常年位居前列。",
    players: [
      { name: "扬尼斯·阿德托昆博", number: 34, position: "大前锋", points: 30.1, rebounds: 11.4, assists: 6.5 },
      { name: "达米安·利拉德", number: 0, position: "控卫", points: 25.2, rebounds: 4.3, assists: 7.1 },
      { name: "克里斯·米德尔顿", number: 22, position: "小前锋", points: 15.8, rebounds: 4.7, assists: 5.2 },
      { name: "布鲁克·洛佩斯", number: 11, position: "中锋", points: 12.6, rebounds: 5.4, assists: 1.6 },
      { name: "马利克·比斯利", number: 9, position: "得分后卫", points: 11.3, rebounds: 3.4, assists: 1.7 },
    ],
  },
  {
    id: "t-den",
    name: "掘金",
    city: "丹佛",
    abbreviation: "DEN",
    conference: "西部",
    primaryColor: "#0E2240",
    secondaryColor: "#FEC524",
    arena: "球场之巅",
    record: "45胜19负",
    coach: "迈克尔·马龙",
    founded: 1967,
    description:
      "丹佛掘金以中锋策应的战术体系著称，进攻端配合默契、传导球流畅。高原主场是高原来访球队的噩梦，球队主场战绩稳居西部前列。",
    players: [
      { name: "尼古拉·约基奇", number: 15, position: "中锋", points: 26.4, rebounds: 12.1, assists: 9.3 },
      { name: "贾马尔·穆雷", number: 27, position: "控卫", points: 20.8, rebounds: 4.1, assists: 6.0 },
      { name: "阿隆·戈登", number: 50, position: "大前锋", points: 13.9, rebounds: 6.5, assists: 3.2 },
      { name: "迈克尔·波特", number: 1, position: "小前锋", points: 16.7, rebounds: 7.0, assists: 1.6 },
      { name: "肯塔维奥斯·考德威尔-波普", number: 5, position: "得分后卫", points: 10.6, rebounds: 2.7, assists: 2.4 },
    ],
  },
  {
    id: "t-mia",
    name: "热火",
    city: "迈阿密",
    abbreviation: "MIA",
    conference: "东部",
    primaryColor: "#98002E",
    secondaryColor: "#F9A01B",
    arena: "卡塞亚中心",
    record: "37胜27负",
    coach: "埃里克·斯波尔斯特拉",
    founded: 1988,
    description:
      "迈阿密热火以铁血防守与严明纪律著称，是联盟最擅长挖掘角色球员的球队之一。球队比赛节奏沉稳，关键时刻执行力强，屡屡在季后赛制造惊喜。",
    players: [
      { name: "吉米·巴特勒", number: 22, position: "小前锋", points: 21.4, rebounds: 5.3, assists: 5.7 },
      { name: "班·阿德巴约", number: 13, position: "中锋", points: 19.2, rebounds: 10.1, assists: 3.8 },
      { name: "泰勒·希罗", number: 14, position: "得分后卫", points: 20.6, rebounds: 5.1, assists: 4.3 },
      { name: "凯尔·洛瑞", number: 7, position: "控卫", points: 9.8, rebounds: 3.8, assists: 5.6 },
      { name: "邓肯·罗宾逊", number: 55, position: "前锋", points: 12.1, rebounds: 2.9, assists: 2.3 },
    ],
  },
  {
    id: "t-phx",
    name: "太阳",
    city: "菲尼克斯",
    abbreviation: "PHX",
    conference: "西部",
    primaryColor: "#1D1160",
    secondaryColor: "#E56020",
    arena: "足迹中心",
    record: "40胜24负",
    coach: "弗兰克·沃格尔",
    founded: 1968,
    description:
      "菲尼克斯太阳拥有联盟顶尖的得分火力，球队以中距离跳投和快速的半场进攻为特色。阵容星光熠熠，进攻端多点开花，是西部不可忽视的劲旅。",
    players: [
      { name: "凯文·杜兰特", number: 35, position: "小前锋", points: 28.2, rebounds: 6.6, assists: 5.4 },
      { name: "德文·布克", number: 1, position: "得分后卫", points: 27.1, rebounds: 4.9, assists: 6.6 },
      { name: "布拉德利·比尔", number: 3, position: "后卫", points: 18.4, rebounds: 4.2, assists: 4.5 },
      { name: "优素福·努尔基奇", number: 20, position: "中锋", points: 11.2, rebounds: 11.1, assists: 2.6 },
      { name: "格雷森·阿伦", number: 8, position: "后卫", points: 12.9, rebounds: 3.6, assists: 3.1 },
    ],
  },
  {
    id: "t-dal",
    name: "独行侠",
    city: "达拉斯",
    abbreviation: "DAL",
    conference: "西部",
    primaryColor: "#00538C",
    secondaryColor: "#B8C4CA",
    arena: "美国航空中心",
    record: "41胜23负",
    coach: "杰森·基德",
    founded: 1980,
    description:
      "达拉斯独行侠围绕组织核心打造进攻体系，挡拆配合炉火纯青。球队擅长在阵地战中寻找错位机会，关键时刻得分能力突出，西部竞争力强劲。",
    players: [
      { name: "卢卡·东契奇", number: 77, position: "控卫", points: 32.4, rebounds: 8.6, assists: 8.9 },
      { name: "凯里·欧文", number: 11, position: "得分后卫", points: 24.6, rebounds: 4.7, assists: 5.2 },
      { name: "丹尼尔·加福德", number: 21, position: "中锋", points: 12.3, rebounds: 7.4, assists: 1.2 },
      { name: "PJ·华盛顿", number: 95, position: "大前锋", points: 13.6, rebounds: 6.1, assists: 2.0 },
      { name: "德雷克·莱夫利", number: 2, position: "中锋", points: 9.4, rebounds: 8.2, assists: 1.5 },
    ],
  },
  {
    id: "t-nyk",
    name: "尼克斯",
    city: "纽约",
    abbreviation: "NYK",
    conference: "东部",
    primaryColor: "#006BB6",
    secondaryColor: "#F58426",
    arena: "麦迪逊广场花园",
    record: "43胜21负",
    coach: "汤姆·锡伯杜",
    founded: 1946,
    description:
      "纽约尼克斯以顽强的防守和强硬的球风著称，主场麦迪逊广场花园气氛震撼。球队轮换稳定，攻防转换效率高，是东部最具韧性的球队之一。",
    players: [
      { name: "杰伦·布伦森", number: 11, position: "控卫", points: 26.8, rebounds: 3.9, assists: 6.8 },
      { name: "朱利叶斯·兰德尔", number: 30, position: "大前锋", points: 22.4, rebounds: 9.2, assists: 4.7 },
      { name: "OG·阿努诺比", number: 8, position: "小前锋", points: 14.7, rebounds: 5.4, assists: 2.1 },
      { name: "约什·哈特", number: 3, position: "后卫", points: 12.6, rebounds: 8.3, assists: 3.6 },
      { name: "米切尔·罗宾逊", number: 23, position: "中锋", points: 8.1, rebounds: 9.8, assists: 1.0 },
    ],
  },
  {
    id: "t-phi",
    name: "76人",
    city: "费城",
    abbreviation: "PHI",
    conference: "东部",
    primaryColor: "#006BB6",
    secondaryColor: "#ED174C",
    arena: "富国银行中心",
    record: "39胜26负",
    coach: "尼克·纳斯",
    founded: 1946,
    description:
      "费城76人以内线核心与稳固防守为基础，球队攻防两端均衡。内线终结效率联盟领先，同时拥有出色的外线火力补充，东部排名稳定。",
    players: [
      { name: "乔尔·恩比德", number: 21, position: "中锋", points: 33.1, rebounds: 10.9, assists: 5.6 },
      { name: "泰瑞斯·马克西", number: 0, position: "控卫", points: 25.9, rebounds: 3.7, assists: 6.4 },
      { name: "托拜厄斯·哈里斯", number: 12, position: "小前锋", points: 16.8, rebounds: 6.2, assists: 2.8 },
      { name: "凯利·乌布雷", number: 5, position: "得分后卫", points: 14.2, rebounds: 5.0, assists: 1.9 },
      { name: "德安东尼·梅尔顿", number: 8, position: "后卫", points: 10.4, rebounds: 3.9, assists: 3.4 },
    ],
  },
  {
    id: "t-okc",
    name: "雷霆",
    city: "俄克拉荷马城",
    abbreviation: "OKC",
    conference: "西部",
    primaryColor: "#007AC1",
    secondaryColor: "#EF3B24",
    arena: "佩克体育馆",
    record: "46胜18负",
    coach: "马克·戴格诺特",
    founded: 1967,
    description:
      "俄克拉荷马城雷霆是一支充满活力的年轻球队，速度与激情是其标签。团队配合默契，转换进攻犀利，防守端压迫性强，是西部崛起的新势力。",
    players: [
      { name: "谢伊·吉尔杰斯-亚历山大", number: 2, position: "后卫", points: 31.2, rebounds: 5.5, assists: 6.3 },
      { name: "切特·霍姆格伦", number: 7, position: "中锋", points: 17.4, rebounds: 8.1, assists: 2.6 },
      { name: "杰伦·威廉姆斯", number: 8, position: "小前锋", points: 19.6, rebounds: 4.3, assists: 4.4 },
      { name: "乔什·吉迪", number: 3, position: "控卫", points: 11.8, rebounds: 6.2, assists: 5.9 },
      { name: "卢根茨·多尔特", number: 5, position: "后卫", points: 10.9, rebounds: 3.6, assists: 1.5 },
    ],
  },
  {
    id: "t-min",
    name: "森林狼",
    city: "明尼苏达",
    abbreviation: "MIN",
    conference: "西部",
    primaryColor: "#0C2340",
    secondaryColor: "#236192",
    arena: "目标中心",
    record: "44胜20负",
    coach: "克里斯·芬奇",
    founded: 1989,
    description:
      "明尼苏达森林狼以内线双塔与联盟顶级防守著称，禁区保护能力出色。球队进攻端逐渐成熟，年轻核心持续进步，是西部竞争格局中的重要力量。",
    players: [
      { name: "安东尼·爱德华兹", number: 5, position: "得分后卫", points: 27.8, rebounds: 5.4, assists: 5.1 },
      { name: "卡尔-安东尼·唐斯", number: 32, position: "中锋", points: 21.3, rebounds: 8.7, assists: 3.2 },
      { name: "鲁迪·戈贝尔", number: 27, position: "中锋", points: 12.9, rebounds: 12.8, assists: 1.2 },
      { name: "贾登·麦克丹尼尔斯", number: 3, position: "小前锋", points: 11.6, rebounds: 5.8, assists: 1.9 },
      { name: "迈克·康利", number: 10, position: "控卫", points: 11.1, rebounds: 2.9, assists: 6.1 },
    ],
  },
];

export const teamMap: Record<string, Team> = teams.reduce(
  (acc, team) => {
    acc[team.id] = team;
    return acc;
  },
  {} as Record<string, Team>,
);